import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { faFileMagnifyingGlass, faSquareCheck, faSquareEllipsis, faSquareXmark } from "@fortawesome/pro-solid-svg-icons"
import { APPROVAL_STATUSES, MEDIA_APPROVAL_STATUSES } from "media/model"

export function getCreativeStatusColor(status: APPROVAL_STATUSES): string {
  switch (status) {
    case APPROVAL_STATUSES.ACTIVE: {
      return "#71CC15"
    }
    case APPROVAL_STATUSES.INACTIVE: {
      return "#BF3623"
    }
    case APPROVAL_STATUSES.PENDING: {
      return "#f3c849"
    }
    case APPROVAL_STATUSES.REFUSED: {
      return "#FF0000"
    }
  }
}

export function getCreativeStatusBackgroundColor(status: APPROVAL_STATUSES): string {
  switch (status) {
    case APPROVAL_STATUSES.ACTIVE: {
      return "#71CC15"
    }
    case APPROVAL_STATUSES.INACTIVE: {
      return "#9F76CB"
    }
    case APPROVAL_STATUSES.PENDING: {
      return "#FFC857"
    }
    case APPROVAL_STATUSES.REFUSED: {
      return "#FF0007"
    }
  }
}

export function getCreativeStatusIcon(status: APPROVAL_STATUSES): IconDefinition {
  switch (status) {
    case APPROVAL_STATUSES.ACTIVE: {
      return faSquareCheck
    }
    case APPROVAL_STATUSES.INACTIVE: {
      return faFileMagnifyingGlass
    }
    case APPROVAL_STATUSES.PENDING: {
      return faSquareEllipsis
    }
    case APPROVAL_STATUSES.REFUSED: {
      return faSquareXmark
    }
  }
}

export function getMediaApprovalStatusColor(status: MEDIA_APPROVAL_STATUSES): string {
  switch (status) {
    case MEDIA_APPROVAL_STATUSES.APPROVED: {
      return "#71CC15"
    }
    case MEDIA_APPROVAL_STATUSES.PENDING: {
      return "#6badc3"
    }
    case MEDIA_APPROVAL_STATUSES.REFUSED: {
      return "#FF0000"
    }
  }
}

export function getMediaApprovalStatusIcon(status: MEDIA_APPROVAL_STATUSES): IconDefinition {
  switch (status) {
    case MEDIA_APPROVAL_STATUSES.APPROVED: {
      return faSquareCheck
    }
    case MEDIA_APPROVAL_STATUSES.PENDING: {
      return faSquareEllipsis
    }
    case MEDIA_APPROVAL_STATUSES.REFUSED: {
      return faSquareXmark
    }
  }
}
